import React from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import overlayFactory from "react-bootstrap-table2-overlay";
import queryString from "app/services/queryStringService";
import _ from "lodash";

import { Helmet } from "react-helmet";

import { getApiUserGroup } from "app/services/MasterAdmin & ApiUSer/apiUserGroupService";
import { useState } from "react";
import { useEffect } from "react";

function OperatorSetting() {
  const [state, setState] = useState({
    page: 1,
    data: [],
    sizePerPage: 10,
    dataCount: 0,
    loading: true,
    selectedMember: null,
    memId: 0,
    showPopup: false,
  });

  const dateFormatter = (row) => {
    return row.split("T")[0];
  };

  const columns = [
    {
      dataField: "name",
      text: "Vendor Name",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "validTo",
      text: "Operator Name",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: dateFormatter,
    },
    {
      dataField: "id",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };
  const NoDataIndication = () => {
    const { loading } = state;
    //alert(loading);
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadUserGroup = async () => {
    const { page, sizePerPage } = state;
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
    });
    if (state.dataCount !== 0) {
      setState((prev) => ({ ...prev, loading: true }));
    }

    const response = await getApiUserGroup(query);
    const data = response.data.data;
    //console.log(data);

    const paggingData = JSON.parse(response.headers["x-pagination"]);
    setState((prev) => ({
      ...prev,
      loading: false,
      data,
      dataCount: paggingData.TotalCount,
      page: paggingData.CurrentPage,
      sizePerPage: paggingData.PageSize,
    }));
  };

  useEffect(() => {
    loadUserGroup();
  }, [state.page, state.sizePerPage]);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    const currentIndex = (page - 1) * sizePerPage;
    setState((prev) => ({ ...prev, page, sizePerPage }));
    setTimeout(async () => {
      await loadUserGroup();
    }, 10);
  };

  const { data, sizePerPage, page, dataCount, loading } = state;

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: state.dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Helmet>
        <title>List of Operator</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "List of Operator" }]}></Breadcrumb>

      <div>
        <BootstrapTable
          hover
          remote
          keyField="id"
          data={state.data}
          columns={columns}
          pagination={paginationFactory(paginationOptions)}
          onTableChange={handleTableChange}
          noDataIndication={() => <NoDataIndication />}
          headerClasses="bg-primary text-white"
          bodyClasses="react-bootstrap-table-next-min-height"
          rowStyle={rowStyle}
        />
      </div>
    </>
  );
}

export default OperatorSetting;
